// @flow
import React, { Component } from 'react'
import {calcImpliedVolatility,calcGreeks} from "../../services/risk";

class OptionBookView extends Component<Props> {

  onCollapse = (key) => {
    console.log(key);
  }
  
  onAddItem = (item, askBid, type, event) => {
    this.props.onAddItem(item, askBid, type, event);
  }

  getBooksData = (books) => {

    return books.map(book=> {
      if(book.call_delta) {
        return book;
      }

      try {

        const dividendYield = 1;
        const riskFreeRate = 1;
        const ds = 0.001;
        const rounding = 2;
        const payload = {
          assetPrice: this.props.stockPrice,
          strikePrice: book.strike,
          expireDay: new Date(book.expiration).getDate(),
          riskFree: riskFreeRate,
          dividendYield: dividendYield,
        }
        const callIv = calcImpliedVolatility({
          ...payload,
          optionType: 'call option',
          marketPrice: (book.call_Ask + book.call_Bid) / 2,
        });
        const putIv = calcImpliedVolatility({
          ...payload,
          optionType: 'put option',
          marketPrice: (book.put_Ask + book.put_Bid) / 2,
        });

        const objCall = calcGreeks({
          ...payload,
          volatility: parseFloat(callIv.volatility),
          ds: ds,
          rounding,
        });

        const objPut = calcGreeks({
          ...payload,
          volatility: parseFloat(putIv.volatility),
          ds: ds,
          rounding,
        });


        book.call_delta = objCall.callResult.delta;
        book.call_iv = callIv.volatility;
        book.call_theta = objCall.callResult.theta;
        book.call_vega = objCall.callResult.vega;

        book.put_delta = objPut.putResult.delta;
        book.put_iv = putIv.volatility;
        book.put_theta = objPut.putResult.theta;
        book.put_vega = objPut.putResult.vega;
      } catch(er) {}
      return book;
    })

  }

  render() {
    const {books, dataCount, stockPrice, nearestIndex} = this.props
    let booksList = dataCount === "all" ? books.length : dataCount
    const bookData = this.getBooksData(books)
    return (
      <div className="book-list" id="book-list" style={{height: booksList * 20}}>
        {bookData.reverse().map((data,i) => {
          const isStrike = stockPrice < data.strike;
          return <div className="divrow" key={i} id={nearestIndex === i ? 'nearest' : ''}>
            <div className={`text-left bg-blue ${isStrike && 'blue'}`}>{data.call_delta}</div>
            <div className={`text-left bg-blue ${isStrike && 'blue'}`}>{data.call_theta}</div>
            <div className={`text-left bg-blue ${isStrike && 'blue'}`}>{data.call_vega}</div>
            <div className={`text-left bg-blue ${isStrike && 'blue'}`}>{data.call_iv}</div>
            <div className={`text-left bg-blue ${isStrike && 'blue'}`}>{data.call_Volume}</div>
            <div className={`text-left bg-blue ${isStrike && 'blue'}`}>{data.call_OpenInterest}</div>
            <div className={`text-left bg-blue ${isStrike && 'blue'}`} style={{cursor: 'pointer'}} onClick={(event) => this.onAddItem(data, 'bid', 'Call', event)}>{data.call_Bid}</div>
            <div className={`text-left bg-blue ${isStrike && 'blue'}`} style={{cursor: 'pointer'}} onClick={(event) => this.onAddItem(data, 'ask', 'Call', event)}>{data.call_Ask}</div>
            <div style={{flex: 2}}>{data.strike}</div>
            <div className={`text-right bg-black ${!isStrike && 'black'}`} style={{cursor: 'pointer'}} onClick={(event) => this.onAddItem(data, 'ask', 'Put', event)}>{data.put_Ask}</div>
            <div className={`text-right bg-black ${!isStrike && 'black'}`} style={{cursor: 'pointer'}} onClick={(event) => this.onAddItem(data, 'bid', 'Put', event)}>{data.put_Bid}</div>
            <div className={`text-right bg-black ${!isStrike && 'black'}`}>{data.put_OpenInterest}</div>
            <div className={`text-right bg-black ${!isStrike && 'black'}`}>{data.put_Volume}</div>
            <div className={`text-right bg-black ${!isStrike && 'black'}`}>{data.put_iv}</div>
            <div className={`text-right bg-black ${!isStrike && 'black'}`}>{data.put_vega}</div>
            <div className={`text-right bg-black ${!isStrike && 'black'}`}>{data.put_theta}</div>
            <div className={`text-right bg-black ${!isStrike && 'black'}`}>{data.put_delta}</div>
          </div>
        })
        }
      </div>
    )
  }
}

export default OptionBookView



// WEBPACK FOOTER //
// ./src/components/option-book/option-book-view.js